Object.defineProperty(exports, '__esModule', { value: true });

var SDK_VERSION = '7.15.0';

exports.SDK_VERSION = SDK_VERSION;
//# sourceMappingURL=version.js.map
